import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-edit',{on:{"edit":function($event){return _vm.$emit('edit')}}},[_c(VCardTitle,{staticClass:"py-2 font-weight-black"},[_vm._v(" "+_vm._s(_vm.$t('delivery.product.products'))+" ")]),_c(VCardText,{staticClass:"px-1 my-0 px-md-12"},[_c('order-items',{attrs:{"items":_vm.$store.getters.orderSystem.order.items}})],1),_c(VDivider)],1)}
var staticRenderFns = []

export { render, staticRenderFns }